"use client";

import { Plane, Building2, Briefcase, PartyPopper } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Plane,
  label: "Airport Transfers",
  description: "Reliable transportation to/from major airports"
}, {
  id: 2,
  icon: Building2,
  label: "City-to-City Rides",
  description: "Comfortable intercity travel services"
}, {
  id: 3,
  icon: Briefcase,
  label: "Corporate Travel",
  description: "Professional business transportation"
}, {
  id: 4,
  icon: PartyPopper,
  label: "Event Transportation",
  description: "Special occasions and night out services"
}];
export default function ComprehensiveTransportationServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section ref={ref} className="relative bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
            Comprehensive Transportation Services
          </h2>
          <p className="mt-4 text-lg text-muted">
            Premium car service solutions for every journey
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={service.id} data-index={i} className="group relative flex flex-col items-center" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(1rem)",
            transition: `opacity var(--duration-medium) var(--ease-smooth) ${i * 150}ms, transform var(--duration-medium) var(--ease-smooth) ${i * 150}ms`
          }}>
                <div className="relative flex h-48 w-full items-center justify-center overflow-hidden rounded-lg bg-secondary shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:-translate-y-2 group-hover:shadow-medium">
                  <Icon className="h-20 w-20 text-foreground-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
                  
                  <div className="absolute inset-x-0 bottom-0 translate-y-full bg-accent px-4 py-3 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:translate-y-0">
                    <p className="text-center text-sm font-medium text-foreground-accent">
                      {service.label}
                    </p>
                  </div>
                </div>

                <div className="mt-4 text-center">
                  <h3 className="font-display text-lg font-semibold text-foreground">
                    {service.label}
                  </h3>
                  <p className="mt-2 text-sm text-muted">
                    {service.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}